
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ArabicFAQSection = () => {
  return (
    <div className="mb-10">
      <h2 className="text-2xl font-semibold mb-6 text-blue-700">الأسئلة المتداولة</h2>
      
      <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm border border-blue-100 mb-6">
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            كم من الوقت يستغرق الحصول على قرار بشأن القرض؟
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            من خلال خدمتنا، ستتلقى عادة عروضًا من بنوك متعددة في غضون 24 ساعة. 
            قد يقدم بعض المقرضين قرارًا أوليًا فوريًا. يعتمد وقت الموافقة النهائية على نوع القرض ومقداره.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-2">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            هل سيؤثر التقديم عبر Lainasampo على درجة الائتمان الخاصة بي؟
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            عندما تتقدم عبر Lainasampo، يتم إجراء فحص ائتماني. في فنلندا، يتم تسجيل هذا الفحص بواسطة Suomen Asiakastieto، 
            ولكن يتم احتساب الطلبات المتعددة من خلال خدمتنا خلال نفس الفترة كاستعلام واحد لأغراض التقييم.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-3">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            ما هو الحد الأدنى والأقصى لمبلغ القرض المتاح؟
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            تختلف مبالغ القرض حسب المقرض ونوع القرض. تتراوح قروض المستهلكين عادة من 1,000 يورو 
            إلى 60,000 يورو، بينما يمكن أن تصل القروض العقارية إلى مئات الآلاف من اليورو. تعتمد المبالغ 
            المحددة المتاحة لك على دخلك وتاريخك الائتماني.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-4">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            هل يمكنني التقديم إذا لم أكن مواطنًا فنلنديًا؟
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            نعم، ولكنك عادة ما تحتاج إلى رقم هوية فنلندي (henkilötunnus) وإقامة دائمة في فنلندا. 
            قد يطلب بعض المقرضين أيضًا أن تكون قد عشت في فنلندا لفترة دنيا (عادة 1-2 سنوات) وأن 
            يكون لديك تاريخ دخل مستقر في فنلندا.
          </AccordionContent>
        </AccordionItem>
        
        <AccordionItem value="item-5">
          <AccordionTrigger className="px-4 py-3 text-right hover:bg-blue-50">
            كيف يتم تحديد أسعار الفائدة؟
          </AccordionTrigger>
          <AccordionContent className="px-4 py-3 text-gray-700">
            يتم تحديد أسعار الفائدة بناءً على وضعك المالي الشخصي ومبلغ القرض ومدة القرض وظروف السوق الحالية. 
            تلعب درجة الائتمان الخاصة بك ومستوى دخلك ووضعك الوظيفي جميعها دورًا في سعر الفائدة الذي يتم عرضه عليك.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
      
      <div className="text-center">
        <Link 
          to="/arabic/apply" 
          className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded shadow-md transition-colors font-medium"
        >
          تقديم طلب للحصول على قرض الآن
          <ArrowRight className="mr-2 h-5 w-5 transform rotate-180" />
        </Link>
      </div>
    </div>
  );
};
